import {
  useEffect,
  useState,
} from 'react';
import {
  Edit3 as Edit3Icon,
  Lock,
  RefreshCcw,
  Trash2 as Trash2Icon,
  Unlock,
} from 'react-feather';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { NewdanhmucnhacungcapAction } from 'src/actions/newdanhmucnhacungcap.action';
import {
  CONFIRM_TYPES,
  DEFAULT_ROW_PER_PAGE,
  ROW_PER_PAGE_OPTIONS,
} from 'src/utils/constants';
import { getNewdanhmucnhacungcapStatus } from 'src/utils/utils';
import ConfirmDialog from '../ConfirmDialog';
import {
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  IconButton,
} from '@material-ui/core';
import CreateEditDialog from './CreateEditDialog';

import numeral from 'numeral';

import { isGrantPermission } from 'src/utils/utils';

const NewdanhmucnhacungcapLookupDetail = ({ ...rest }) => {
  const dispatch = useDispatch()
  const [selectedNewdanhmucnhacungcapIds, setSelectedNewdanhmucnhacungcapIds] = useState([]);
  const [limit, setLimit] = useState(DEFAULT_ROW_PER_PAGE);
  const [page, setPage] = useState(0);
  const { items, total, filter } = useSelector(state => state.newdanhmucnhacungcap);
  const [confirm, setConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [selected, setSelected] = useState({});
  const [open, setOpen] = useState(false);
  const { info, permissions, role } = useSelector(state => state.profile)

  useEffect(() => {
    const payload = {
      ...filter,
      limit: limit,
      page: page,
    };
    dispatch(NewdanhmucnhacungcapAction.updateFilter(payload));
    dispatch(NewdanhmucnhacungcapAction.list())
  }, [page, limit])

  const handleSelectAll = (event) => {
    let newSelectedNewdanhmucnhacungcapIds;

    if (event.target.checked) {
      newSelectedNewdanhmucnhacungcapIds = items.map((newdanhmucnhacungcap) => newdanhmucnhacungcap.id);
    } else {
      newSelectedNewdanhmucnhacungcapIds = [];
    }

    setSelectedNewdanhmucnhacungcapIds(newSelectedNewdanhmucnhacungcapIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedNewdanhmucnhacungcapIds.indexOf(id);
    let newSelectedNewdanhmucnhacungcapIds = [];

    if (selectedIndex === -1) {
      newSelectedNewdanhmucnhacungcapIds = newSelectedNewdanhmucnhacungcapIds.concat(selectedNewdanhmucnhacungcapIds, id);
    } else if (selectedIndex === 0) {
      newSelectedNewdanhmucnhacungcapIds = newSelectedNewdanhmucnhacungcapIds.concat(selectedNewdanhmucnhacungcapIds.slice(1));
    } else if (selectedIndex === selectedNewdanhmucnhacungcapIds.length - 1) {
      newSelectedNewdanhmucnhacungcapIds = newSelectedNewdanhmucnhacungcapIds.concat(selectedNewdanhmucnhacungcapIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedNewdanhmucnhacungcapIds = newSelectedNewdanhmucnhacungcapIds.concat(
        selectedNewdanhmucnhacungcapIds.slice(0, selectedIndex),
        selectedNewdanhmucnhacungcapIds.slice(selectedIndex + 1)
      );
    }

    setSelectedNewdanhmucnhacungcapIds(newSelectedNewdanhmucnhacungcapIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleConfirmOpen = (type, newdanhmucnhacungcap) => {
    setSelected(newdanhmucnhacungcap);
    setConfirmType(type);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      setTitle("Xoá bản ghi")
      setContent(`Xác nhận xoá bản ghi `)
    }
    setConfirm(true);
  };

  const onConfirm = () => {
    setConfirm(false);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      dispatch(NewdanhmucnhacungcapAction.del(selected.id))
      return;
    }
  }

  const handleConfirmClose = () => {
    setConfirm(false);
  };

  const onSelected = (id) => {
    dispatch(NewdanhmucnhacungcapAction.findOne(id));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const setColor = (value) => {
    if (value == 'MOBIFONE') return 'green';
    else if (value == 'VINAPHONE') return 'blue';
    else if (value == 'VIETTEL') return 'red';
    else return 'black';
  };

  return (
    <Card {...rest} style={{ width: "100%"}}>
      <PerfectScrollbar>
        <Box sx={{ minWidth: '500px', width: '100%' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  #
                </TableCell>
                <TableCell>
                  Mã
                </TableCell>
                <TableCell>
                  Tên
                </TableCell>
                <TableCell>
                  Mã số thuế
                </TableCell>
                <TableCell>
                  Địa chỉ
                </TableCell>
                <TableCell>
                  Số điện thoại
                </TableCell>
                <TableCell>
                  Email
                </TableCell>
                <TableCell>
                  Thời điểm tạo
                </TableCell>
                {(role.priority < 4) && <TableCell>
                  Chức năng
                </TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {items && Object.values(items).length > 0 && items.slice(page * limit, page * limit + limit).map((newdanhmucnhacungcap, index) => (
                newdanhmucnhacungcap ? <TableRow
                  hover
                  key={newdanhmucnhacungcap.id}
                  selected={selectedNewdanhmucnhacungcapIds.indexOf(newdanhmucnhacungcap.id) !== -1}
                >
                  <TableCell>
                    {page * limit + index + 1}
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {newdanhmucnhacungcap.ma}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {newdanhmucnhacungcap.ten}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {newdanhmucnhacungcap.mst}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {newdanhmucnhacungcap.dia_chi}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {newdanhmucnhacungcap.sdt}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {newdanhmucnhacungcap.email}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {moment(newdanhmucnhacungcap.createdAt).format('DD-MM-YYYY HH:mm:ss')}
                    </Typography>
                  </TableCell>
                  {(role.priority < 4) && <TableCell>
                    <IconButton aria-label="edit" onClick={() => onSelected(newdanhmucnhacungcap.id)}>
                      <Edit3Icon color='green' />
                    </IconButton>
                    <IconButton aria-label="delete" onClick={() => handleConfirmOpen(CONFIRM_TYPES.DELETE, newdanhmucnhacungcap)}>
                      <Trash2Icon color='red' />
                    </IconButton>
                  </TableCell>}
                </TableRow> : null
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={total}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={ROW_PER_PAGE_OPTIONS}
      />
      <CreateEditDialog open={open} handleClose={handleClose} type={"EDIT"} />
      <ConfirmDialog open={confirm} title={title} content={content || `Xác nhận xoá bản ghi `} highlight={selected.so_dien_thoai_co_dau_cham} handleClose={handleConfirmClose} handleConfirm={onConfirm} />
    </Card>
  );
};

export default NewdanhmucnhacungcapLookupDetail;
